// ----------------------------------------------------------------------

const breakpoints = {
  values: {
    xs: 0,
    se: 400,
    ss: 300,
    mb: 350,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  }
};

export default breakpoints;
